import React from 'react';
import { HtmlStringRenderer } from 'components/HtmlStringRenderer';
import { ExpandableArea } from 'ui/ExpandableArea/ExpandableArea';

interface IRoomBenefitsProps {
  moreInformation?: string;
  title: string;
  containerClassName?: string;
}

export const RoomBenefits: React.FC<IRoomBenefitsProps> = (props) => {
  if (!props.moreInformation) {
    return null;
  }

  return (
    <ExpandableArea title={props.title} containerClassName={props.containerClassName}>
      <HtmlStringRenderer content={props.moreInformation} fallbackComponent="span" />
    </ExpandableArea>
  )
};
